import React from "react";
import { Icon } from "@clarkinc/zest-design-system/ui";
import { cls } from "@wss/cls";
interface Props {
  link: string;
  title: string;
  displayResourceLink: boolean;
}
const ResourceLink = ({
  link,
  title,
  displayResourceLink
}: Props) => {
  return <li className={cls("item", displayResourceLink ? "flex" : "hidden")} data-no-jquery data-sentry-component="ResourceLink" data-sentry-source-file="ResourceLink.tsx">
      <Icon theme="wss" name="ri-book-open-line" size="xsmall" className="mr-1 px-1.5" data-sentry-element="Icon" data-sentry-source-file="ResourceLink.tsx" />
      <a className="description" href={link} title={title} target="_blank">
        {title}
      </a>
    </li>;
};
export default ResourceLink;